module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/june-b626ddeed623da61b5b25a2f59320d62.png";